var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.2939 11.8306L37.5593 1.67504C36.4175 0.594826 34.9231 0 33.3513 0H12.9141C9.53781 0 6.79102 2.7468 6.79102 6.12305V50.877C6.79102 54.2532 9.53781 57 12.9141 57H44.0859C47.4622 57 50.209 54.2532 50.209 50.877V16.2786C50.209 14.6032 49.511 12.982 48.2939 11.8306ZM45.0502 13.3594H36.7383C36.4313 13.3594 36.1816 13.1097 36.1816 12.8027V4.96924L45.0502 13.3594ZM44.0859 53.6602H12.9141C11.3794 53.6602 10.1309 52.4116 10.1309 50.877V6.12305C10.1309 4.58839 11.3794 3.33984 12.9141 3.33984H32.8418V12.8027C32.8418 14.9513 34.5898 16.6992 36.7383 16.6992H46.8691V50.877C46.8691 52.4116 45.6206 53.6602 44.0859 53.6602Z",
    fill: "#06038D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4121 22.2656H15.9199C14.9977 22.2656 14.25 23.0133 14.25 23.9355C14.25 24.8578 14.9977 25.6055 15.9199 25.6055H40.4121C41.3344 25.6055 42.082 24.8578 42.082 23.9355C42.082 23.0133 41.3344 22.2656 40.4121 22.2656Z",
    fill: "#06038D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4121 31.1719H15.9199C14.9977 31.1719 14.25 31.9196 14.25 32.8418C14.25 33.764 14.9977 34.5117 15.9199 34.5117H40.4121C41.3344 34.5117 42.082 33.764 42.082 32.8418C42.082 31.9196 41.3344 31.1719 40.4121 31.1719Z",
    fill: "#06038D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0157 40.0781H15.9199C14.9977 40.0781 14.25 40.8258 14.25 41.748C14.25 42.6703 14.9977 43.418 15.9199 43.418H24.0157C24.9379 43.418 25.6856 42.6703 25.6856 41.748C25.6856 40.8258 24.9379 40.0781 24.0157 40.0781Z",
    fill: "#06038D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument1);
export default __webpack_public_path__ + "static/media/document 1.25e5e2b9ade9f755f4513db7daf7b7c8.svg";
export { ForwardRef as ReactComponent };